import { get } from 'svelte/store';
import { replace } from 'svelte-spa-router';

import { JUMP_TYPE_ENUM } from '../enums';
import { LOGIN_STATE_CK } from '../enums/track';
import { activityId, isJumpOneLink, isLoading, isLogin } from '../store/index';

import {
    receiveRewardAndSaveClaim,
    trackReceiveRewardFailure
} from './claimReward';
import { JumpLink } from './jumpTo';
import { isMsiPage } from './pageType';
import { getMatchedRewardActivityId } from './rewardClaimStorage';
import { sleep } from './sleep';
import { trackEvent } from './track';

import { pageLeave } from '@/utils/fmpTrack';

const POST_REWARD_JUMP_DELAY_MS = 300;

const resetCtaUiState = () => {
    isLoading.set(false);
    isJumpOneLink.set(false);
};

type LandingCtaOptions = {
    buttonName?: string;
    extraTrack?: Record<string, unknown>;
};

/** 仅 card-msi：已登录且已领奖则直达申卡，否则先领奖再跳转 */
export const handleLandingCtaClick = async ({
    buttonName = 'next',
    extraTrack = {}
}: LandingCtaOptions) => {
    if (get(isLoading)) {
        return;
    }

    trackEvent(LOGIN_STATE_CK, {
        button_name: buttonName,
        is_have_check_agreement_btn: 'no_have',
        ...extraTrack
    });

    if (!isMsiPage()) {
        if (get(isLogin)) {
            isJumpOneLink.set(true);
            await JumpLink(JUMP_TYPE_ENUM.TO_H5CREDITCARD);

            return;
        }

        isJumpOneLink.set(true);
        pageLeave();
        await replace('/login');

        return;
    }

    if (!get(isLogin)) {
        isJumpOneLink.set(true);
        pageLeave();
        await replace('/login');

        return;
    }

    isJumpOneLink.set(true);
    isLoading.set(true);

    try {
        const claimedAid = getMatchedRewardActivityId();

        if (claimedAid) {
            activityId.set(claimedAid);
            pageLeave();
            await sleep(POST_REWARD_JUMP_DELAY_MS);

            if (!(await JumpLink(JUMP_TYPE_ENUM.TO_H5CREDITCARD))) {
                resetCtaUiState();
            }

            return;
        }

        pageLeave();

        try {
            await receiveRewardAndSaveClaim();
        } catch (err) {
            trackReceiveRewardFailure(err);
        }

        if (!(await JumpLink(JUMP_TYPE_ENUM.TO_H5CREDITCARD))) {
            resetCtaUiState();
        }
    } catch (err) {
        resetCtaUiState();
        throw err;
    }
};
